angular.module('rjmNg.services').factory "dashboardItemLoadQueue", [
  "app"
  "Figures"
  "Rjql"
  "Charts"
  "notification"
  "figureEnums"
  "$routeParams"
  "modelRequestEnum"
  "$timeout"
  "utils"
  "figureService"
  "reportQueryType"
  "$rootScope"
  "$cacheFactory"
  "md5"
  "dashboardService"
  "DashboardTimeOptions"
  "$q"
  "ReportViews"
  "DashboardDividers"
  (
    app
    Figures
    Rjql
    Charts
    notification
    figureEnums
    $routeParams
    modelRequestEnum
    $timeout
    utils
    figureService
    reportQueryType
    $rootScope
    $cacheFactory
    md5
    dashboardService
    DashboardTimeOptions
    $q
    ReportViews
    DashboardDividers
  ) ->
    _maxConcurrentLoad = 3 # max number of dashboard items to load at a time
    _modelRequestTimeoutSecs = modelRequestEnum.TIMEOUTS.REQUEST_TIMEOUT_SECS
    _maxPollingSecs = modelRequestEnum.TIMEOUTS.MAX_POLLING_INTERVAL_SECS
    _pollingFigureIds = {}
    _pollingChartIds = {}
    _onDashboard = true
    _dashItemsIncompleteCount = 0
    _queueChartCacheFlag = app.hasFeatureFlag('QUEUE_CHART_CACHE_JOBS')
    _requestedFigureIds = if _queueChartCacheFlag then {} else []
    _requestedChartIds = if _queueChartCacheFlag then {} else []
    _rjqlIdCache = $cacheFactory('rjqlIdCache')
    _dashboardTimeOptions = null
    _dashboardInterval = null

    RJQL_JOB_POLLING_INTERVAL_SEC = 1 * 1000
    RJQL_VERSION = app.getRjqlVersion()
    DEFAULT_META =
      perspectiveName: null

    _getFigureRequestParams = (dashboardId = null) ->
      requestOptions =
        params:
          data: true
          query: true

      if $routeParams.ccacheoff is "1"
        requestOptions.params.ccacheoff = true
      if $routeParams.qcacheoff is "1"
        requestOptions.params.qcacheoff = true
      if $routeParams.ccommitoff is "1"
        requestOptions.params.ccommitoff = true
      if $routeParams.timeoutoff is "1"
        requestOptions.params.timeoutoff = true
      if $routeParams.redshifton is "1"
        requestOptions.params.redshifton = true
      if $routeParams.rjqlcacheoff is "1"
        requestOptions.params.rjqlcacheoff = true

      if dashboardId?
        requestOptions.params.dashboardId = dashboardId

      return requestOptions

    # Load dashboardItems in a 'multi-threaded' manner
    _multiThreadedLoad = (getCallback, idArray, dashboardItems, forceGet = false) ->
      # don't request the same dashboardItem twice.
      ids = _(idArray).uniq()
      threads = if ids.length >= _maxConcurrentLoad then _maxConcurrentLoad else ids.length
      for i in [1..threads] when ids.length > 0
        getCallback ids, dashboardItems, forceGet, false

    _generateDashboardMeta = (dashboardItem) ->
      meta = angular.copy(DEFAULT_META)
      if RJQL_VERSION is 1.0 and figureService.isCohortFigure(dashboardItem.figure)
        measure = dashboardItem.figure.query.select.measures[0]
        perspective = figureService.identifyDataPerspective(measure, RJQL_VERSION)
        meta.perspectiveName = figureEnums.DATA_PERSPECTIVES[perspective]
      return meta

    _addFigureAndMetaToDashboardItem = (dashboardItems, figure) ->
      for item in dashboardItems when item.figureId is figure.id
        item.figure = figure
        try
          item.meta = _generateDashboardMeta(item)
        catch error
          console.error(error)
          item.meta = angular.copy(DEFAULT_META)

    getRjqlIdsForStatus = (collection, statuses) ->
      filteredCol = collection.filter((c) -> c.status in statuses)
      filteredCol.map((c) -> c.id)

    getFigureFromRjqlJobId = (jobId, figures) ->
      rjqlId = parseInt((jobId.split "_")[1])
      return f for f in figures when f.rjqlId is rjqlId

    _getFiltersHash = () ->
      filtersJsonString = JSON.stringify(
        storeFilters: dashboardService.extraDashboardFilters
        timerange: _dashboardTimeOptions
        interval: _dashboardInterval
      )
      md5.createHash(filtersJsonString)

    _getFromRjqlIdCache = (rjqlId) ->
      cacheSubKey = _getFiltersHash()
      _rjqlIdCache.get(rjqlId)?[cacheSubKey]

    _putToRjqlIdCache = (rjqlId, data) ->
      cacheKey = rjqlId
      cacheSubKey = _getFiltersHash()
      value = _rjqlIdCache.get(rjqlId) or {}
      value[cacheSubKey] = data
      _rjqlIdCache.put(cacheKey, value)

    _fetchRjqlData = (collection, dashData) ->
      Rjql(app.getClientId()).getRjqlJobPayloads(collection).then (response) ->
        for rjqlPayload in response.collection
          figure = f for f in dashData.figures when f.rjqlId is rjqlPayload.rjql_id
          if rjqlPayload.error?
            {code, message} = rjqlPayload.error
            figure.error = rjqlPayload.error
            _getErrorCallback({status: code}, figure.id, "figure", dashData.dashboardItems, message)
          else
            figure.data = rjqlPayload.payload.data
            figure.query = rjqlPayload.payload.query
            _putToRjqlIdCache(rjqlPayload.rjql_id, rjqlPayload)

          _addFigureAndMetaToDashboardItem(dashData.dashboardItems, figure)
          _setDashboardItemWarningsForFigure(dashData.dashboardItems, figure)
      , (error) ->
        figures = collection.map((jobId) -> getFigureFromRjqlJobId(jobId, dashData.figures))
        _getErrorCallback(error, f.id, "figure", dashData.dashboardItems) for f in figures

    _renderFailedRjqlFigures = (failedJobs, dashData) ->
      for job in failedJobs
        figure = getFigureFromRjqlJobId(job.id, dashData.figures)
        _pollingFigureIds[figure.id] = false
        _getErrorCallback({status: 500}, figure.id, "figure", dashData.dashboardItems, job.message)

    _setCacheInProgressWarning = (inProgressJobIds, dashData) ->
      for job in inProgressJobIds
        figure = getFigureFromRjqlJobId(job, dashData.figures)
        warnings =
          cacheInProgress: true
        for item in dashData.dashboardItems when item.figureId is figure.id
          item.warnings = warnings
          item.figure = {warnings}

    _pollRjqlJobs = (collection, dashData, canceller) ->
      if collection?.length and not canceller.cancel
        Rjql(app.getClientId()).getRjqlJobs(collection).then (response) ->
          inProgressIds = getRjqlIdsForStatus(response.collection, ["init", "progress"])
          successIds = getRjqlIdsForStatus(response.collection, ["done"])
          failedJobs = response.collection.filter((c) -> c.status is "error")

          if successIds?.length
            _fetchRjqlData(successIds, dashData)

          if inProgressIds?.length
            _setCacheInProgressWarning(inProgressIds, dashData)
          if failedJobs?.length
            _renderFailedRjqlFigures(failedJobs, dashData)

          $timeout _pollRjqlJobs, RJQL_JOB_POLLING_INTERVAL_SEC, true, inProgressIds, dashData, canceller
        , (error) ->
          # do nothing here since this will be polled

      if collection?.length and canceller.cancel
        figures = collection.map((jobId) -> getFigureFromRjqlJobId(jobId, dashData.figures))
        _getErrorCallback({status: 500}, f.id, "figure", dashData.dashboardItems) for f in figures

      if collection?.length is 0
        ReportViews.logDashboardView(dashData.dashId)
        $rootScope.$broadcast "dashboardItemsLoadEnd"

    _queueRjqlJobs = (figures, dashboardItems, dashId) ->
      uncachedRjqlIds = []
      cachedRjqlIds = []
      for figure in figures
        cached = _getFromRjqlIdCache(figure.rjqlId)
        if not cached?
          uncachedRjqlIds.push figure.rjqlId
        else
          cachedRjqlIds.push figure.rjqlId

      filter = (a) -> a.filter((r) -> r?)

      uncachedRjqlIds = filter(uncachedRjqlIds)
      cachedRjqlIds = filter(cachedRjqlIds)

      dashData =
        figures: figures
        dashboardItems: dashboardItems
        dashId: dashId

      requestOptions = _getFigureRequestParams()

      if(uncachedRjqlIds.length > 0)
        $rootScope.$broadcast "dashboardItemsLoadStart"
        Rjql(app.getClientId()).createRjqlJobs(
          uncachedRjqlIds
          dashboardService.extraDashboardFilters
          _dashboardTimeOptions
          _dashboardInterval
          requestOptions.params.rjqlcacheoff
        ).then (response) ->
          canceller =
            cancel: false

          uncachedJobs = response.collection.filter (j) -> typeof j is "string"
          cachedJobs = response.collection.filter (j) -> typeof j is "object"
          for payload in cachedJobs
            figure = f for f in dashData.figures when f.rjqlId is payload.rjql_id
            if payload.error?
              {code, message} = payload.error
              figure.error = payload.error
              _getErrorCallback({status: code}, figure.id, "figure", dashboardItems, message)
            else
              figure.data = payload.data
              figure.query = payload.query
              _putToRjqlIdCache(payload.rjql_id, {payload})

            _addFigureAndMetaToDashboardItem(dashData.dashboardItems, figure)
            _setDashboardItemWarningsForFigure(dashData.dashboardItems, figure)

          _pollRjqlJobs(uncachedJobs, dashData, canceller)
        , (error) ->
          _getErrorCallback(error, figure.id, "figure", dashboardItems) for figure in figures

      if(cachedRjqlIds.length > 0)
        for rjqlId in cachedRjqlIds
          figure = f for f in dashData.figures when f.rjqlId is rjqlId
          rjqlPayload = _getFromRjqlIdCache(rjqlId)
          figure.data = rjqlPayload.payload.data
          figure.query = rjqlPayload.payload.query
          _addFigureAndMetaToDashboardItem(dashData.dashboardItems, figure)

    _addOldValueToDivider = (divider) ->
      angular.extend(
        angular.copy(divider)
        {oldValue: divider.value}
      )

    # Populate the dashboardItems powered by the rjql service
    _getRjqlServiceFigures = (figureIdArray, dashboardItems, forceGet = false, getStale = false, isGA = false) ->
      dashId = +$routeParams.dashId
      promises = [
        Figures.getByDashboardId(dashId)
        DashboardDividers.getByDashboardId(dashId)
      ]
      if app.hasFeatureFlag('DASHBOARD_WIDE_TIME_RANGES')
        promises.push DashboardTimeOptions(dashId).get()

      $q.all(promises)
      .then ([figures, dividers, dwto]) ->
        _dashboardTimeOptions = dwto?.timerange
        _dashboardInterval = dwto?.interval
        rjqlFigures = figures.filter((f) -> f.reportQueryType is 'rjql')
        _queueRjqlJobs(rjqlFigures, dashboardItems, dashId)

        sqlFigureIds = (figure.id for figure in figures when figure.reportQueryType is 'sql')
        if sqlFigureIds.length then _getFigures(sqlFigureIds, dashboardItems)

        for div in dividers
          item.divider = _addOldValueToDivider(div) for item in dashboardItems when item.dividerId is div.id
      , (error) ->
        _getErrorCallback(error, id, "figure", dashboardItems) for id in figureIdArray

    # Populate the dashboardItems with Figures
    _getFigures = (figureIdArray, dashboardItems, forceGet = false, getStale = false, isGA = false) ->
      unless figureIdArray.length
        return

      figureId = figureIdArray.shift()
      dashId = +$routeParams.dashId
      requestOptions = _getFigureRequestParams(dashId)

      isPolling = !!_pollingFigureIds[figureId]
      timeoutSecs = if isPolling then _maxPollingSecs else _modelRequestTimeoutSecs
      unless isGA # if getting a GA figure, don't timeout
        angular.extend(requestOptions, {timeout: timeoutSecs * 1000})
      if _queueChartCacheFlag or figureId in _requestedFigureIds # don't recalculate / recache the model if we already requested it
        angular.extend(requestOptions.params, {recache: false})
      if isPolling then forceGet = true
      if getStale
        requestOptions.params.data = false
        forceGet = false

      if _queueChartCacheFlag
        if figureId not of _requestedFigureIds and requestOptions.params.data
          _requestedFigureIds[figureId] = 1
        else
          _requestedFigureIds[figureId] += 1
      else
        if figureId not in _requestedFigureIds and requestOptions.params.data
          _requestedFigureIds.push figureId

      Figures.get(figureId, forceGet, requestOptions).then (figure) ->
        _handleFigureSuccess figure, figureId, figureIdArray, dashboardItems, dashId

      , (error) ->
        # if the figure request timed out, put it back on the front of the queue,
        # and get stale data so that the dashboard item isn't totally useless
        timedOut = utils.requestWasCanceled(error) and error.config?.timeout?
        if timedOut and dashId is +$routeParams.dashId
          if figureId not in figureIdArray and not _pollingFigureIds[figureId]
            figureIdArray.unshift(figureId)
          _pollingFigureIds[figureId] = true
        else
          _pollingFigureIds[figureId] = false

        if figureIdArray.length
          _getFigures(figureIdArray, dashboardItems, false, timedOut)

        _getErrorCallback(error, figureId, "figure", dashboardItems)

    # Figure object returned from controller--attempt to render it, or, if the data
    # is still calculating, show a warning and poll for fresh data.
    _handleFigureSuccess = (pristineFigure, figureId, figureIdArray, dashboardItems, dashId) ->
      figure = utils.copy pristineFigure

      _pollingFigureIds[figureId] = false

      timedOut = figure.id? and not figure.data? and not figure.error?
      stillCaching = _.isEmpty(figure.data) and figure.error?.code is figureEnums.WARNING_CODES.CACHE_IN_PROGRESS
      isGA = figure.reportQueryType is reportQueryType.RJQL and figure.query? and figureService.containsGaMetric(figure)

      if stillCaching or timedOut
        _addCalculationInProgressWarningsToFigure figure
        _enqueueInProgressFigure figureId, isGA, figureIdArray, dashboardItems, dashId
        delete figure.data

      # remove existing warnings from the dashboard item if we have a fresh figure
      if not (timedOut or stillCaching)
        delete item.warnings for item in dashboardItems when item.figureId is figure.id

      # delete the backend's caching error--we just render using the warnings
      delete figure.error if figure.error?.code is figureEnums.WARNING_CODES.CACHE_IN_PROGRESS

      if figureIdArray.length and _onDashboard and dashId is +$routeParams.dashId
        _getFigures(figureIdArray, dashboardItems, false, false, isGA)

      # Match it with any dashboard items using it
      _addFigureAndMetaToDashboardItem(dashboardItems, figure)

      # Set error on the dashboard item if applicable
      if figure.error? then item.error = figure.error for item in dashboardItems when item.figureId is figure.id
      if figure.data?.error? then item.error = figure.data.error for item in dashboardItems when item.figureId is figure.id

      _setDashboardItemWarningsForFigure(dashboardItems, figure)

      # this is a major error so show it at the dashboard level
      if(figure.error?.code is 500)
        notification.error("Chart Error", figure.error.message)

      _dashItemsIncompleteCount--

    _enqueueInProgressFigure = (figureId, isGA, figureIdArray, dashboardItems, dashId) ->
      $timeout ->
        if dashId is +$routeParams.dashId and _onDashboard
          _pollingFigureIds[figureId] = true
          if isGA # immediately put the GA figure onto the front of the queue
            if figureId not in figureIdArray then figureIdArray.unshift figureId
          else # all other figures go to the back of the queue after a timeout
            if figureId not in figureIdArray then figureIdArray.push figureId
          if figureIdArray.length is 1
            _getFigures(figureIdArray, dashboardItems, false, false, isGA)
      , if isGA then 0 else _getPollingIntervalMillisecs(figureId)

    _getPollingIntervalMillisecs = (modelId, isFigure = true) ->
      if _queueChartCacheFlag
        maxExponent = Math.log(_maxPollingSecs)/Math.log(2)
        numRequests = if isFigure then _requestedFigureIds[modelId] else _requestedChartIds[modelId]
        numRequests ?= maxExponent
        return Math.pow(2,Math.min(numRequests, maxExponent)) * 1000
      else
        return _maxPollingSecs * 1000

    _addCalculationInProgressWarningsToFigure = (figure) ->
      figure.warnings = [
          code: figureEnums.WARNING_CODES.IS_STALE
        ,
          code: figureEnums.WARNING_CODES.CACHE_IN_PROGRESS
        ]

    _setDashboardItemWarningsForFigure = (dashboardItems, figure) ->
        warnings =
          dataTruncated: false
          compositeSortWarning: false
          isStale: false
          cacheInProgress: false
          gaDataTruncated: false

        if figure.data?.warnings?
          for warning in figure.data.warnings
            warnings.compositeSortWarning = true if warning.code is figureEnums.WARNING_CODES.COMPOSITE_SORT
            warnings.dataTruncated = true if warning.code is figureEnums.WARNING_CODES.DATA_TRUNCATED
            warnings.gaDataTruncated = true if warning.code is figureEnums.WARNING_CODES.GA_DATA_TRUNCATED
            warnings.isStale = true if warning.code is figureEnums.WARNING_CODES.IS_STALE
            warnings.cacheInProgress = true if warning.code is figureEnums.WARNING_CODES.CACHE_IN_PROGRESS

          item.warnings = warnings for item in dashboardItems when item.figureId is figure.id

        if not figure.data? and figure.warnings?
          # we explicitly added warnings if we timed out from the front-end, assuming a cache-miss
          for warning in figure.warnings
            warnings.cacheInProgress = true if warning.code is figureEnums.WARNING_CODES.CACHE_IN_PROGRESS
            warnings.isStale = true if warning.code is figureEnums.WARNING_CODES.IS_STALE

          item.warnings = warnings for item in dashboardItems when item.figureId is figure.id

        if not figure.data?.warnings? and not figure.warnings?
          # clear any previous warnings
          for item in dashboardItems when item.figureId is figure.id
            delete item.warnings

    # Populate the dashboardItems with Charts
    _getCharts = (chartIdArray, dashboardItems, forceGet = false, getStale = false) ->
      chartId = chartIdArray.shift()

      isPolling = !!_pollingChartIds[chartId]
      timeoutSecs = if isPolling then _maxPollingSecs else _modelRequestTimeoutSecs
      timeoutMillisecs = timeoutSecs * 1000
      if isPolling then forceGet = true
      if getStale then forceGet = false
      if _queueChartCacheFlag
        doRecache = false
        if chartId not of _requestedChartIds and not getStale
          _requestedChartIds[chartId] = 1
        else
          _requestedChartIds[chartId] += 1
      else
        if chartId in _requestedChartIds # don't recalculate / recache the model if we already requested it
          doRecache = false
        else if chartId not in _requestedChartIds and not getStale
          _requestedChartIds.push chartId

      dashId = +$routeParams.dashId

      Charts.getChartData(chartId, forceGet, timeoutMillisecs, getStale, doRecache).then (chart) ->

        _handleChartSuccess(chart, chartId, chartIdArray, dashboardItems, dashId, forceGet)

      , (error) ->
        timedOut = utils.requestWasCanceled(error) and not error.data?
        if timedOut and dashId is +$routeParams.dashId
          if chartId not in chartIdArray and not _pollingChartIds[chartId]
            chartIdArray.unshift(chartId)
          _pollingChartIds[chartId] = true
        else
          _pollingChartIds[chartId] = false

        if chartIdArray.length
          _getCharts(chartIdArray, dashboardItems, false, timedOut)

        _getErrorCallback(error, chartId, "chart", dashboardItems)

    _handleChartSuccess = (pristineChart, chartId, chartIdArray, dashboardItems, dashId, forceGet) ->
      chart = utils.copy pristineChart

      _pollingChartIds[chartId] = false

      stillCaching = chart.warnings?.cacheInProgress and chart.warnings?.isStale

      if stillCaching
        $timeout ->
          if dashId is +$routeParams.dashId and _onDashboard
            _pollingChartIds[chartId] = true
            if chartId not in chartIdArray then chartIdArray.push chartId
            if chartIdArray.length is 1 then _getCharts(chartIdArray, dashboardItems)
        , _getPollingIntervalMillisecs(chartId, false)
      else
        delete item.warnings for item in dashboardItems when item.chartId is chart.id

      if chartIdArray.length and _onDashboard and dashId is +$routeParams.dashId
        _getCharts(chartIdArray, dashboardItems, false, false)

      # Match it with any dashboard items using it
      item.chart = chart for item in dashboardItems when item.chartId is chart.id

      if chart.error? then item.error = chart.error for item in dashboardItems when item.chartId is chart.id

      if chart.warnings? then item.warnings = chart.warnings for item in dashboardItems when item.chartId is chart.id

      # this is a major error so show it at the dashboard level
      if(chart.error?.major)
        notification.error("Chart Error", chart.error.message)

      # If this chart has a figure and we're force loading it, we probably saved
      # Update the figure cache as well
      if chart.figureId? and forceGet and not stillCaching
        requestParams = _getFigureRequestParams($routeParams.dashId)
        Figures.get(chart.figureId, true, requestParams)

      _dashItemsIncompleteCount--

    # On error callback function
    _getErrorCallback = (error, id, chartOrFigure, dashboardItems, errorMessage = null) ->
      errorMessage ?= "Error loading chart. If error persists please contact support."

      unless utils.requestWasCanceled error
        notification.error("#{chartOrFigure} error", errorMessage)

        whereClause = {}
        whereClause[chartOrFigure + "Id"] = id

        dashboardItems = _(dashboardItems).where whereClause

        for dItem in dashboardItems
          dItem[chartOrFigure] =
            error:
              message: errorMessage
            data: null
          dItem.error = dItem[chartOrFigure].error

      _dashItemsIncompleteCount--

    $rootScope.$on "reloadRjqlFigure", (event, rjqlId) ->
      if rjqlId?
        _rjqlIdCache.remove(rjqlId)
      else
        _rjqlIdCache.removeAll()

    observeRouteChange : (onDashboard) ->
      if onDashboard
        _onDashboard = true
        _pollingFigureIds = {}
        _pollingChartIds = {}
        if _queueChartCacheFlag
          _requestedFigureIds = {}
          _requestedChartIds = {}
      else
        _onDashboard = false

    load: (dashboardItems, forceGet = false) ->

      _dashItemsIncompleteCount = dashboardItems.length

      sortedDashboardItems = _(dashboardItems).sortBy "row"

      chartIds = []
      figureIds = []

      for dItem in sortedDashboardItems

        # Fork loading of charts vs figures
        if dItem.figureId?
          figureIds.push dItem.figureId
        else
          chartIds.push dItem.chartId

      if app.hasFeatureFlag('RJQL_SERVICE_CLIENT')
        _getRjqlServiceFigures(figureIds, dashboardItems, forceGet, false, false)
      else
        _multiThreadedLoad(_getCharts, chartIds, dashboardItems, forceGet)
        _multiThreadedLoad(_getFigures, figureIds, dashboardItems, forceGet)

      return dashboardItems
]
